import { Controller } from 'react-hook-form'
import { inspectionTargetOptions } from '@@api/flightLog.shared'
import type { FlightLogSectionContext } from '../useFlightLogForm'
import { DateRow, HmmRow } from '../../ui/prntr-fields'
import { PrntrGroup } from '../../ui/prntr-input'
import { RichToggleRow, SegmentedSwitch } from '../SegmentedSwitch'

export function InspectionSection({
  context,
  hasPreviousInspection,
  keepPrevious,
  onKeepPreviousChange,
}: {
  context: FlightLogSectionContext
  // The aircraft's previous submitted log carries next-inspection figures
  hasPreviousInspection: boolean
  // "Same as previous log" — fields are locked to the carried-over values
  keepPrevious: boolean
  onKeepPreviousChange: (keep: boolean) => void
}) {
  const { control, readOnly, fieldError } = context
  const locked = readOnly || (hasPreviousInspection && keepPrevious)
  return (
    <>
      {hasPreviousInspection && (
        <div className="flex flex-col gap-2 py-2">
          <RichToggleRow
            title="Same as previous flight log"
            checked={keepPrevious}
            onChange={onKeepPreviousChange}
            readOnly={readOnly}
          />
          {keepPrevious && (
            <p className="text-xs text-content-primary-subtle">
              Carried over from the previous log — switch off to change.
            </p>
          )}
        </div>
      )}
      <div className="py-2">
        <Controller
          control={control}
          name="inspection.target"
          render={({ field }) => (
            <SegmentedSwitch
              options={inspectionTargetOptions}
              value={field.value}
              onChange={field.onChange}
              readOnly={locked}
            />
          )}
        />
      </div>
      <PrntrGroup>
        <HmmRow
          control={control}
          name="inspection.dueHours"
          label="Due Hourly"
          readOnly={locked}
          error={fieldError('inspection.dueHours')}
        />
        <DateRow
          control={control}
          name="inspection.dueDate"
          label="Due Calendar"
          readOnly={locked}
          error={fieldError('inspection.dueDate')}
        />
      </PrntrGroup>
    </>
  )
}
